

const formatTimeRemaining = (seconds) => {
    const hours = Math.floor(seconds/3600);
    const minutes = Math.floor((seconds / 60) % 60);
    const secs = seconds % 60;
    return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

export default formatTimeRemaining;